module.exports = __webpack_public_path__ + "img/img_country_map.d2c067ce.png";